export default __webpack_public_path__ + "static/media/settings.5d2d2658.svg";